export default {
  'rank.name': 'Member class',
  'rank.title': 'Import',
  'rank.heading': 'List of members',
  'rank.code': 'Name of class',
  'rank.discount': 'Ratio ',
  'rank.minimumRevenue': 'Minimum amount',
};
